// import { useContext} from "react";
// import { PageContext } from "../store/context/context";

import logo from "../assets/images/logo.png";
import { IoMenuSharp } from "react-icons/io5";
// import resume from "../assets/documents/resume.pdf";
// import { IoHome } from "react-icons/io5";
// import { IoPerson } from "react-icons/io5";
// import { IoMail } from "react-icons/io5";
// import { IoLogoLinkedin } from "react-icons/io5";
// import { IoDocumentText } from "react-icons/io5";
// import { IoLogoGithub } from "react-icons/io5";

function Header() {
  // const pageCtx = useContext(PageContext);
  const icon_size = 43;

  // function onNavClick(newPage) {
  //   pageCtx.setPage(newPage);
  // }

  return (
    <div id="mobile-nav" className="flex justify-center mx-5 my-5">
      <nav className="flex justify-center w-screen">
        {/* Logo */}
        <div className="flex items-center justify-begin flex-1">
          <img
            className=""
            src={logo}
            width={56}
            height="auto"
            alt="logo"
            title="Logo"
          />
        </div>
        {/* Hamburger Menu */}
        <div className="hidden flex-1 flex justify-end items-center ml-auto">
          <IoMenuSharp className="icon mx-1" size={icon_size} />
        </div>
      </nav>
    </div>
  );
}

export default Header;